import { render, staticRenderFns } from "./imgCard.vue?vue&type=template&id=5fc71eac&scoped=true&"
import script from "./imgCard.vue?vue&type=script&lang=js&"
export * from "./imgCard.vue?vue&type=script&lang=js&"
import style0 from "./imgCard.vue?vue&type=style&index=0&id=5fc71eac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc71eac",
  null
  
)

export default component.exports